module.exports = __webpack_public_path__ + "media/common/icons/linkio_logo_white-adf7d78a3eb3ba6bcdbf6438a50150fb.svg";